<template>
  <vue-final-modal
    v-model="showDeleteModal"
    name="deleteAccountModal"
    classes="modal-container"
    content-class="modal-content"
    :click-to-close="false"
    :lock-scroll="false">
    <div class="modal-data">
      <h1>Eliminar la cuenta</h1>
      <p class="modal-message">Para eliminar tu cuenta, introduce tu email</p>
      <div class="form-modal">
        <BaseInput
          v-model="userEmail"
          :required="true"
          label="Email"
          :error="isValidEmail"
        />
        <div class="apiAlert" v-if="apiError">
          <p>{{ apiErrorMessage }}</p>
        </div>
        <button class="btn-form" @click="deleteAccount" :disabled="isValidEmail !== true">Eliminar cuenta</button>
      </div>
    </div>
    <button class="btn-cookies-black" @click="showDeleteModal = !showDeleteModal">Cancelar</button>
  </vue-final-modal>
</template>

<script>
import BaseInput from '@/components/BaseInput.vue'
import ApiService from '@/services/ApiService'
import LocalStorageService from '@/services/LocalStorageService'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'DeleteAccountModal',
  data () {
    return {
      showDeleteModal: false,
      userEmail: null,
      apiError: false,
      apiErrorMessage: ''
    }
  },
  components: {
    BaseInput
  },
  computed: {
    ...mapState(['idContest']),
    isValidEmail () {
      if (this.userEmail !== null) {
        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!regex.test(String(this.userEmail).toLowerCase())) {
          return 'El formato del email no es válido'
        }
        return true
      } else return ''
    }
  },
  methods: {
    ...mapMutations(['changeLoading', 'setEmail', 'setToken']),
    async deleteAccount () {
      this.apiError = false
      this.changeLoading(true)
      const dataToSend = {
        id: this.idContest,
        email: this.userEmail
      }
      try {
        const response = await ApiService.deleteAccountAPI(dataToSend)
        if (response.data.code === 200) {
          this.setEmail(null)
          this.setToken(null)
          LocalStorageService.setStringify(
            'session',
            {
              userEmail: null,
              token: null
            }
          )
          this.$vfm.hide('deleteAccountModal')
          this.$swal({
            icon: 'success',
            title: 'Cuenta eliminada correctamente',
            html: `
              <p>Se ha eliminado correctamente tu cuenta de usuario.</p>
              <p>Si quieres volver a participar debes volver a registarte.</p>
            `,
            confirmButtonColor: '#000000',
            confirmButtonText: '<i class="fa fa-check"></i> Ok'
          })
          this.changeLoading(false)
        } else if (response.data.code === 401) {
          this.apiError = true
          this.apiErrorMessage = 'No hay ninguna cuenta con este email'
          localStorage.removeItem('userEmail')
          this.changeLoading(false)
        } else if (response.data.code === 404) {
          this.apiError = false
          LocalStorageService.setStringify(
            'session',
            {
              userEmail: null,
              token: null
            }
          )
          this.$vfm.hide('deleteAccountModal')
          this.$router.push('/')
          this.changeLoading(false)
        } else {
          this.apiError = true
          this.apiErrorMessage = 'Ha habido un error al enviar los datos, prueba de nuevo en unos minutos'
          this.changeLoading(false)
        }
      } catch (error) {
        this.apiError = true
        this.apiErrorMessage = 'Ha habido un error al enviar los datos, prueba de nuevo en unos minutos'
        this.changeLoading(false)
      }
    }
  },
  created () {
    if (LocalStorageService.getParsed('userEmail') !== false) {
      this.userEmail = LocalStorageService.getParsed('userEmail')
    } else {
      return null
    }
  }
}
</script>

<style scoped>
:deep(.modal-container) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;
  overflow-y: auto;
  padding: 1rem;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  width: 100%;
}
:deep(.modal-content) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.75rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-top: auto;
  margin-bottom: auto;
  padding: 2rem;
  width: 375px;
}
:deep(.modal-data) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
}
:deep(.modal-content h1) {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 1rem;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
:deep(.modal-message) {
  text-align: left;
}
:deep(.form-modal) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  width: 100%;
}
:deep(.btn-form) {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
}
:deep(.btn-form):hover {
  opacity: 0.9;
}
:deep(.btn-form):focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-form):focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-form:disabled) {
  cursor: not-allowed;
  opacity: 0.6;
}
:deep(.btn-link) {
  cursor: pointer;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  color: var(--primary);
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}
:deep(.btn-link):focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-link):focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-cookies-black):hover {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
:deep(.btn-cookies-black) {
  border-radius: 0.25rem;
  border-width: 2px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  width: 100%;
}
:deep(.btn-cookies-black):focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-cookies-black):focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.apiAlert) {
  --tw-bg-opacity: 1;
  background-color: rgba(216, 38, 46, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
  --tw-border-opacity: 1;
  border-color: rgba(216, 38, 46, var(--tw-border-opacity));
  border-radius: 0.5rem;
  border-width: 1px;
  margin-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
</style>
